import Vue from 'vue'
import App from './App.vue'
// 引入reset.css
import "@/assets/common/styles/reset.css"



import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  loading: ''				// 替换需要的图片
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
